/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnalyticsSignalDimension,
  AnalyticsSignalDimension$inboundSchema,
} from "./analyticssignaldimension.js";
import {
  AnalyticsSignalFilter,
  AnalyticsSignalFilter$inboundSchema,
} from "./analyticssignalfilter.js";
import {
  AnalyticsSignalSelection,
  AnalyticsSignalSelection$inboundSchema,
} from "./analyticssignalselection.js";

export type AnalyticsSignalMetadata = {
  coverage: string;
  exact: boolean;
  filters: Array<AnalyticsSignalFilter>;
  from: Date;
  groupBy: Array<AnalyticsSignalDimension>;
  groupsTruncated: boolean;
  physicalResolution: string;
  pointBudget: number;
  population: string;
  queriedAt: Date;
  runId?: string | undefined;
  selection: AnalyticsSignalSelection;
  seriesComplete: boolean;
  /**
   * Live, not a replayable historical snapshot
   */
  snapshot: string;
  step: string;
  timeAxis: string;
  to: Date;
  trigger: string;
  unit: string;
};

/** @internal */
export const AnalyticsSignalMetadata$inboundSchema: z.ZodMiniType<
  AnalyticsSignalMetadata,
  unknown
> = z.pipe(
  z.object({
    coverage: z.string(),
    exact: z.boolean(),
    filters: z.array(AnalyticsSignalFilter$inboundSchema),
    from: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    group_by: z.array(AnalyticsSignalDimension$inboundSchema),
    groups_truncated: z.boolean(),
    physical_resolution: z.string(),
    point_budget: z.int(),
    population: z.string(),
    queried_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    run_id: z.optional(z.string()),
    selection: AnalyticsSignalSelection$inboundSchema,
    series_complete: z.boolean(),
    snapshot: z.string(),
    step: z.string(),
    time_axis: z.string(),
    to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    trigger: z.string(),
    unit: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "group_by": "groupBy",
      "groups_truncated": "groupsTruncated",
      "physical_resolution": "physicalResolution",
      "point_budget": "pointBudget",
      "queried_at": "queriedAt",
      "run_id": "runId",
      "series_complete": "seriesComplete",
      "time_axis": "timeAxis",
    });
  }),
);

export function analyticsSignalMetadataFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalMetadata' from JSON`,
  );
}
